import { render, staticRenderFns } from "./LmDocumentExpirationDate.vue?vue&type=template&id=786332d1"
import script from "./LmDocumentExpirationDate.vue?vue&type=script&lang=js"
export * from "./LmDocumentExpirationDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports